import React from 'react';

interface ILeftIconProps {
  children: React.ReactNode;
}

export const LeftIcon: React.FC<ILeftIconProps> = ({ children }) => (
  <span className="left-icon tw-lf-input-left-icon" aria-hidden="true">
    {children}
  </span>
);
